import styles from "./UsageControls.module.scss";
import Select from "@JohnLewisPartnership/jl-design-system/dist/elements/select/Select";
import Input from "@JohnLewisPartnership/jl-design-system/dist/elements/input/Input";
import { periodOptions, usageOptions, yearOptions } from "../../../utils";
import { useState } from "react";

export type Props = {
  customUsageTimesPerPeriod: number | null;
  customUsagePeriod: number | null;
  customEnergyCostYears: number;
  customTariff: number;
  onChangeUsage: (name: string, value: string | number) => void;
};

const UsageControls = ({
  customUsageTimesPerPeriod,
  customUsagePeriod,
  customEnergyCostYears,
  customTariff,
  onChangeUsage,
}: Props) => {
  const [tariff, setTariff] = useState(customTariff.toString());
  const requiresUsageAmount = customUsageTimesPerPeriod && customUsagePeriod;
  const usageYearsLabel = !requiresUsageAmount
    ? "I'll use it for roughly"
    : "for roughly";

  return (
    <div className={styles.usage}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (isNaN(Number(tariff))) {
            setTariff(customTariff.toString());
            return;
          }
          onChangeUsage("customTariff", tariff);
        }}
      >
        {requiresUsageAmount && (
          <div className={styles.usage__control}>
            <label htmlFor={"usage-times"}>I&apos;ll use it</label>
            <Select
              id="usage-times"
              name="usage-times"
              data-testid="usage-times"
              ariaLabel="I'll use it"
              options={usageOptions}
              value={
                customUsageTimesPerPeriod &&
                customUsageTimesPerPeriod.toString()
              }
              onChange={(e: { target: HTMLSelectElement }) => {
                onChangeUsage("customUsageTimesPerPeriod", e.target.value);
              }}
            ></Select>
          </div>
        )}

        {requiresUsageAmount && (
          <div className={styles.usage__control}>
            <label htmlFor={"usage-period"}>times a</label>
            <Select
              id="usage-period"
              name="usage-period"
              data-testid="usage-period"
              ariaLabel="times a"
              options={periodOptions}
              value={customUsagePeriod && customUsagePeriod.toString()}
              onChange={(e: { target: HTMLSelectElement }) => {
                onChangeUsage("customUsagePeriod", e.target.value);
              }}
            ></Select>
          </div>
        )}

        <div className={styles.usage__control}>
          <label htmlFor={"usage-years"}>{usageYearsLabel}</label>
          <Select
            id="usage-years"
            name="usage-years"
            data-testid="usage-years"
            ariaLabel={usageYearsLabel}
            options={yearOptions}
            value={customEnergyCostYears.toString()}
            onChange={(e: { target: HTMLSelectElement }) => {
              onChangeUsage("customEnergyCostYears", e.target.value);
            }}
          ></Select>
        </div>

        <div className={styles.usage__control}>
          <label htmlFor={"usage-tariff"}>and my current tariff is</label>
          <div className={styles.usage__tariffInput}>
            <Input
              id="usage-tariff"
              name="usage-tariff"
              autoComplete="off"
              value={tariff}
              onChange={(e: { target: HTMLInputElement }) => {
                setTariff(e.target.value.toString());
              }}
              onBlur={(e: { target: HTMLInputElement }) => {
                if (isNaN(Number(e.target.value))) {
                  setTariff(customTariff.toString());
                }
              }}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default UsageControls;
